module.exports = __webpack_public_path__ + "static/p1-5959c5dbe1e55757a87a38097cb69c77.jpg";